import React from "react";

import {ModalBtn} from "../../components/Modals";
import Device from "../../components/Device";
import ReactMarkdown from "react-markdown";
import {Checkbox, Form} from "antd";

let WaiverPopup = () => <ModalBtn style={{top: 20}} footer={null} width={!Device.xs && 600} text="Wavier" asLink>
  <div className="my-markdown">
    <ReactMarkdown>
      {gon.tournament.waiver || "Waiver Text"}
    </ReactMarkdown>
  </div>
</ModalBtn>

export default () => {
  const validateCheckbox = (_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('waiver must be accepted'));
  };

  return <Form.Item valuePropName="checked" name="waiver" rules={[{validator: validateCheckbox}]} >
    <Checkbox>I accept the <WaiverPopup /></Checkbox>
  </Form.Item>
}
